import { useContext } from 'react';
import { MentorModalContext } from '../contexts/MentorModalContext';

export function useMentorModal() {
  const context = useContext(MentorModalContext);
  if (context === undefined) {
    throw new Error('useMentorModal must be used within a MentorModalProvider');
  }
  return context;
}
